import React from "react";

export interface IconWrapProps {
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    className?: string;
    style?: React.CSSProperties;

    children: React.ReactNode;
}

const IconWrap = ({ width = 14, height = 14, viewBox = "0 0 48 48", className, children, style, ...rest }: IconWrapProps) => (
    <svg width={width} height={height} viewBox={viewBox} className={className} xmlns="http://www.w3.org/2000/svg" style={style} {...rest}>
        {children}
    </svg>
);

export default IconWrap;
